import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col } from 'reactstrap';
import { H5, Image } from '../../../../AbstractElements';

import SvgIcon from '../../../Common/Component/SvgIcon';
import UserStats, { SocialLinks } from './UserStats';

const CardProfileUnique = ({ 
  id, 
  avatar, 
  icon, 
  name, 
  email, 
  totalPost, 
  follower, 
  following 
}) => {
  return (
    <Col xl='12' sm='12' className='col-ed-12 box-col-12'>
      <Card className='social-profile'>
        <CardBody>
          <div className='social-img-wrap'>
            <div className='social-img'>
              <Image attrImage={{ src: require(`../../../../assets/images/${avatar}`), alt: 'profile' }} />
            </div>
            <div className='edit-icon'>
              <SvgIcon iconId={icon} />
            </div>
          </div>
          <div className='social-details'>
            <H5 attrH5={{ className: 'mb-1' }}>
              <a href={`#`} onClick={(event) => event.preventDefault()} className='f-w-500'>{name}</a>
            </H5>
            <span className='f-light'>{email}</span>
            <SocialLinks />
            <UserStats totalPost={totalPost} follower={follower} following={following} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CardProfileUnique;

